<template>
  <div id="desktop">
    <img class="bgImg bgImgRatio" :src="this.bgCastle">


    <img class="QR" v-if="this.language == 'TC'" src="../assets/images/general/QRTC.png"/>
    <img class="QR" v-if="this.language == 'EN'" src="../assets/images/general/QREN.png"/>

    <img class="disneyLogo" :src="this.logo"/>

  </div>
</template>

<script>
  import i18n from '@/language';
  import * as commonFunction from '@/commonFunction/commonFunction'
  import { store } from '../store'
  import base64BgCastle from '@/assets/images/base64/bgCastle.js';
  import base64Logo from '@/assets/images/base64/logo.js';

  export default {
    name: 'desktop',
    components: {

    },
    data () {
      return {
        language : i18n.locale,
        logo : base64Logo.data,
        bgCastle : base64BgCastle.data
      }
    },

    beforeCreate(){

    },

    created(){

      if (!commonFunction.checkIsDesktop() && !commonFunction.checkIsIpad()) {
        window.location.href = "#/";
      }

    },

    methods:{

    },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},

  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
  },


  }
</script>

<style scoped>
  #desktop{
    position: fixed;
    width: 100%;
    height: 100%;
  }
  .bgImg{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
  }

  @media (max-aspect-ratio: 1680 / 945){.bgImgRatio{height: 100%; min-width: 100%;max-height: 100%}}
  @media (min-aspect-ratio: 1680 / 945){.bgImgRatio{width: 100%; min-width: 100%;min-height: 100%}}

  .disneyLogo{
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translate3d(-50%,0,0);
    width: 120px;
    height: auto;
  }

  .QR{
    position: absolute;
    left: 50%;
    top: 10vh;
    transform: translate3d(-50%,0,0);
/*    top: 50%;
    transform: translate3d(-50%,-65%,0);
    width: 35vw;
    max-width: 60vh;*/
    width: 45vw;
  }

</style>




// WEBPACK FOOTER //
// src/pages/desktop.vue